/**
 * @generated SignedSource<<8d14e05a8155e21ba6115a686cd66aa4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type previewNewslettersPreviewPageQuery$variables = {
  entityId?: string | null | undefined;
};
export type previewNewslettersPreviewPageQuery$data = {
  readonly newsletter: {
    readonly newsletterCategories: ReadonlyArray<{
      readonly newsletterCount: {
        readonly edges: ReadonlyArray<{
          readonly __typename: "NewsletterEdge";
        }>;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"newsletterCategoryItemSlideshowNewsletterCategory">;
    } | null | undefined> | null | undefined;
    readonly sourceUrl: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"mobileNewsletterPreviewNewsletter" | "newsletterDetailsNewsletter" | "newsletterItemNewsletter" | "signUpButtonNewsletter">;
  };
};
export type previewNewslettersPreviewPageQuery = {
  response: previewNewslettersPreviewPageQuery$data;
  variables: previewNewslettersPreviewPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityId"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityId",
        "variableName": "entityId"
      }
    ],
    "kind": "ObjectValue",
    "name": "filter"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sourceUrl",
  "storageKey": null
},
v3 = {
  "kind": "Literal",
  "name": "first",
  "value": 100
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": "newsletterCount",
  "args": [
    (v3/*: any*/)
  ],
  "concreteType": "NewsletterConnection",
  "kind": "LinkedField",
  "name": "newsletters",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "NewsletterEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v4/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": "newsletters(first:100)"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = [
  (v6/*: any*/),
  (v8/*: any*/)
],
v10 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "shortDescription",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "Image",
  "kind": "LinkedField",
  "name": "images",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "summary",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "FormattedValue",
  "kind": "LinkedField",
  "name": "description",
  "plural": false,
  "selections": (v10/*: any*/),
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numberOfSignedUpUsers",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegment",
  "kind": "LinkedField",
  "name": "sections",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": (v9/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v4/*: any*/),
    (v16/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UrlRedirect",
      "kind": "LinkedField",
      "name": "urlRedirect",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "toUrl",
          "storageKey": null
        },
        (v8/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Application",
      "kind": "LinkedField",
      "name": "application",
      "plural": false,
      "selections": (v9/*: any*/),
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "fullSectionPath",
          "plural": true,
          "selections": (v9/*: any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "parentSection",
          "storageKey": null
        }
      ],
      "type": "Section",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "flattenTypeIds",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LiveArticle",
          "kind": "LinkedField",
          "name": "liveArticle",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            (v8/*: any*/)
          ],
          "storageKey": null
        },
        (v17/*: any*/)
      ],
      "type": "Article",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v17/*: any*/),
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PaywallType",
              "kind": "LinkedField",
              "name": "paywallTypes",
              "plural": true,
              "selections": [
                (v16/*: any*/),
                (v8/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "type": "Article",
          "abstractKey": null
        }
      ],
      "type": "Content",
      "abstractKey": "__isContent"
    }
  ],
  "type": "BaseWithApplicationAndUrlAlias",
  "abstractKey": "__isBaseWithApplicationAndUrlAlias"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "previewNewslettersPreviewPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Newsletter",
        "kind": "LinkedField",
        "name": "newsletter",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NewsletterCategory",
            "kind": "LinkedField",
            "name": "newsletterCategories",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "newsletterCategoryItemSlideshowNewsletterCategory"
              }
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "mobileNewsletterPreviewNewsletter"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "newsletterDetailsNewsletter"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "newsletterItemNewsletter"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "signUpButtonNewsletter"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "previewNewslettersPreviewPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Newsletter",
        "kind": "LinkedField",
        "name": "newsletter",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "NewsletterCategory",
            "kind": "LinkedField",
            "name": "newsletterCategories",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": [
                  (v3/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "orderBy",
                    "value": {
                      "direction": "DESC",
                      "field": "WEIGHT"
                    }
                  }
                ],
                "concreteType": "NewsletterConnection",
                "kind": "LinkedField",
                "name": "newsletters",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "NewsletterEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Newsletter",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "NewsletterCategory",
                            "kind": "LinkedField",
                            "name": "newsletterCategories",
                            "plural": true,
                            "selections": (v9/*: any*/),
                            "storageKey": null
                          },
                          (v11/*: any*/),
                          (v12/*: any*/),
                          (v13/*: any*/),
                          (v14/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormattedValue",
                            "kind": "LinkedField",
                            "name": "longDescription",
                            "plural": false,
                            "selections": (v10/*: any*/),
                            "storageKey": null
                          },
                          (v15/*: any*/),
                          (v8/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "newsletters(first:100,orderBy:{\"direction\":\"DESC\",\"field\":\"WEIGHT\"})"
              },
              (v8/*: any*/)
            ],
            "storageKey": null
          },
          (v6/*: any*/),
          (v7/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v12/*: any*/),
          (v11/*: any*/),
          (v8/*: any*/),
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e4c684499af05db57dacfbc71ccd2222",
    "id": null,
    "metadata": {},
    "name": "previewNewslettersPreviewPageQuery",
    "operationKind": "query",
    "text": "query previewNewslettersPreviewPageQuery(\n  $entityId: String\n) {\n  newsletter(filter: {entityId: $entityId}) {\n    sourceUrl\n    newsletterCategories {\n      newsletterCount: newsletters(first: 100) {\n        edges {\n          __typename\n        }\n      }\n      ...newsletterCategoryItemSlideshowNewsletterCategory\n      id\n    }\n    ...mobileNewsletterPreviewNewsletter\n    ...newsletterDetailsNewsletter\n    ...newsletterItemNewsletter\n    ...signUpButtonNewsletter\n    id\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Article {\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sections {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersNewsletterSlideshowItemGetSizeNewsletter on Newsletter {\n  newsletterCategories {\n    entityId\n    id\n  }\n  shortDescription {\n    text\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment mobileNewsletterPreviewNewsletter on Newsletter {\n  entityId\n  name\n  summary {\n    text\n  }\n  sourceUrl\n  ...signUpButtonNewsletter\n}\n\nfragment mynewsNewsletterItemNewsletter on Newsletter {\n  name\n  images {\n    title\n    url\n  }\n  summary {\n    text\n  }\n  description {\n    text\n  }\n  longDescription {\n    text\n  }\n  ...entityLink\n}\n\nfragment newsletterCategoryItemSlideshowNewsletterCategory on NewsletterCategory {\n  entityId\n  name\n  newsletters(first: 100, orderBy: {field: WEIGHT, direction: DESC}) {\n    edges {\n      node {\n        entityId\n        name\n        ...helpersNewsletterSlideshowItemGetSizeNewsletter\n        ...mynewsNewsletterItemNewsletter\n        ...newsletterItemNewsletter\n        ...plusNewsletterItemNewsletter\n        id\n      }\n    }\n  }\n}\n\nfragment newsletterDetailsNewsletter on Newsletter {\n  name\n  entityId\n  newsletterCategories {\n    name\n    id\n  }\n  summary {\n    text\n  }\n  description {\n    text\n  }\n  ...entityLink\n  ...signUpButtonNewsletter\n}\n\nfragment newsletterItemNewsletter on Newsletter {\n  name\n  numberOfSignedUpUsers\n  images {\n    title\n    url\n  }\n  summary {\n    text\n  }\n  description {\n    text\n  }\n  shortDescription {\n    text\n  }\n  ...entityLink\n  ...signUpButtonNewsletter\n}\n\nfragment plusNewsletterItemNewsletter on Newsletter {\n  name\n  numberOfSignedUpUsers\n  entityId\n  images {\n    title\n    url\n  }\n  summary {\n    text\n  }\n  description {\n    text\n  }\n  shortDescription {\n    text\n  }\n  ...entityLink\n  ...signUpButtonNewsletter\n}\n\nfragment signUpButtonNewsletter on Newsletter {\n  entityId\n  name\n  ...entityLink\n}\n"
  }
};
})();

(node as any).hash = "43ebf1180d4eefdf98bc0efe5056b84e";

export default node;
